// extracted by css-extract-rspack-plugin
export default {"list":"list-rxOVwn","row":"row-a7pyF7","head":"head-V7bG1e","title":"title-pLSGYp","value":"value-k77tkA","editor":"editor-h3BIRS","actions":"actions-MnTKk4"};